const clientId = '5e9fa224-519b-820e-7c66-d03710993464';
const baseApiUrl = 'https://wsp.pradagroup.net/friendsoutletcardfs-ws/';
const apiUrl = `${baseApiUrl}api/`;
const host = 'https://friendsoutletcardfs.pradagroup.net/';
const adfsRedirectUri = `${host}sign-in`;
const baseWWAdfsUrl = 'https://sts.pradagroup.net/';
const baseItaAdfsUrl = 'https://myprada.pradagroup.net/sts/';
const referredItaAdfs = 'https://myprada.pradagroup.net/';

export const environment = {
  production: false,
  name: 'production',
  appName: 'Friends Outlet Card',
  storageVersion: '1.0.0',
  baseApiUrl,
  apiUrl,
  host,
  baseWWAdfsUrl,
  baseItaAdfsUrl,
  referredItaAdfs,
  authInterceptorUrls: [apiUrl, baseWWAdfsUrl, baseItaAdfsUrl],
  signOutUrl: 'http://my-prada.pradagroup.com/',
  mockApiUrl: 'https://localhost:3002/',
  sockets: { url: '' },
  httpRetryConfig: {
    enabled: true,
    verbs: {
      get: { enabled: true, timeout: 6000, maxRetries: 2, retryForStatusesCodes: [500] },
      post: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      patch: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      put: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
      delete: { enabled: false, timeout: null, maxRetries: 1, retryForStatusesCodes: [500] },
    },
  },
  loggerConfig: {
    enabled: false,
    maxLogRentention: 20,
    logHttpErrorsWithStatusesCodes: ['0', '4XX', '5XX'],
    logDecoratedExceptions: true,
    logExceptions: true,
    saveLogMessagesInterval: 30000,
    logUrl: 'https://logs.logdna.com/logs/ingest?apikey=bf8cf553dba4a1e882fa09491aaed2c7',
    sendLogs: true,
    sendRequestBody: false,
    sendQueryParams: false,
  },
  tagManager: {
    enabled: false,
    apiKey: '',
  },
  registerServiceWorker: false,
  clientId,
  adfsRedirectUri,
  // tslint:disable-next-line:max-line-length
  adfsUrl: `https://sts.pradagroup.net/adfs/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${adfsRedirectUri}&resource=${baseApiUrl}`,
};
